module.exports = __webpack_public_path__ + "static/img/EMMC200-i74F8zny.041de63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/EMMC200-i74F8zny.png
// module id = +ARl
// module chunks = 16